import { popperContentProps as o } from "./index569.js";
import { useDelayedToggleProps as e } from "./index690.js";
import { buildProps as t, definePropType as r } from "./index601.js";
import { useAriaProps as p } from "./index650.js";
import { teleportProps as n } from "./index644.js";
const m = t({
  ...e,
  ...o,
  /**
   * @description which element the tooltip CONTENT appends to
   */
  appendTo: {
    type: n.to.type
  },
  /**
   * @description display content, can be overridden by `slot#content`
   */
  content: {
    type: String,
    default: ""
  },
  /**
   * @description whether `content` is treated as HTML string
   */
  rawContent: Boolean,
  /**
   * @description when tooltip inactive and `persistent` is `false` , popconfirm will be destroyed
   */
  persistent: Boolean,
  // because model toggle prop is generated dynamically
  // so the typing cannot be evaluated by typescript as type:
  // [name]: { type: Boolean, default: null }
  // so we need to declare that again for type checking.
  /**
   * @description visibility of Tooltip
   */
  visible: {
    type: r(Boolean),
    default: null
  },
  /**
   * @description animation name
   */
  transition: String,
  /**
   * @description whether tooltip content is teleported, if `true` it will be teleported to where `append-to` sets
   */
  teleported: {
    type: Boolean,
    default: !0
  },
  /**
   * @description whether Tooltip is disabled
   */
  disabled: Boolean,
  ...p(["ariaLabel"])
});
export {
  m as useTooltipContentProps
};
